export default __webpack_public_path__ + "static/media/pcpbreakdown.63d47c3c.png";